import { render, staticRenderFns } from "./PaymentMethodDetails.vue?vue&type=template&id=5334cc51&scoped=true"
import script from "./PaymentMethodDetails.vue?vue&type=script&lang=ts"
export * from "./PaymentMethodDetails.vue?vue&type=script&lang=ts"
import style0 from "./PaymentMethodDetails.vue?vue&type=style&index=0&id=5334cc51&prod&lang=scss&scoped=true"
import style1 from "./PaymentMethodDetails.vue?vue&type=style&index=1&id=5334cc51&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5334cc51",
  null
  
)

export default component.exports